import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 18px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height: 100%;
  width: 100%;
  // max-width: 414.15px;
  min-width: 200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  &:hover {
    outline: 5px solid #ffcb29;
  }
`;
